module.exports = "<input [class]=\"className\" name=\"abn\" type=\"text\" placeholder=\"ABN\" [formControl]=\"control\"> <p class=\"form__info\" *ngIf=\"name | async\">{{ name | async }}</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/abn/abn-input.component.html
// module id = ./src/app/shared/components/abn/abn-input.component.html
// module chunks = 21